<script context="module">
  export const NORMAL = 'NORMAL';
  export const NARROW = 'NARROW';
  export const NONE = 'NONE';
</script>

<script>
  export let padding = NORMAL;
  export let width = NORMAL;
</script>

<div
  class="body-content"
  class:width-narrow={width == NARROW}
  class:padding-normal={padding == NORMAL}
  class:padding-narrow={padding == NARROW}
  class:padding-none={padding == NONE}
>
  <slot />
</div>

<style>
  .body-content {
    position: relative;
    max-width: 1440px;
    margin: 0 auto;
    padding: 0 16px;
    z-index: 5;
  }

  @media screen and (min-width: 992px) {
    .body-content.padding-normal {
      padding: 0 70px;
    }
    .body-content.width-narrow {
      max-width: 720px;
    }
  }

  .body-content.padding-none {
    padding: unset;
  }
</style>
